export enum ArticleVideoEditorState {
  default = 'default',
  recording = 'video-recording',
  inserting = 'video-inserting',
  recorded = 'video-recorded',
  cancel = 'cancel-recording',
}
